import React from 'react';

export default function Blog005() {
  return (
    <section>
    <article>
      <h2>5. 08-13-2022</h2>
      <h3>Tutorials</h3>
      <p>
        While building the text based game I have run into a few road blocks. I know what I would like the app to do, but I do not know what code to write. <br />
        This is a perfect learning opportunity. <br />
        I have decided to follow a few tutorials that have some code implementation that appears to be what I am missing on my current project. 
        <br />
        I would like to have the game running properly before uploading a copy of it. 
        <br />
        I have followed one tutorial today, 'Build a quiz game' by 'Web Dev Simplified'. I really enjoy his formatting and quick pace.
         I added a bit of CSS cosmetics to the final product and turned it into a math quiz. In this project I learned how to use the display:hide, onclick, accessing information from an object, and replacing divs and buttons in Javascript.
        <br />
        <br />
        My focus for these tutorials:
        <br />
      </p>
        <ul>
          <li>Create a function Start and Restart Button</li>
          <li>Create a Game Over</li>
          <li>Create a way to keep score</li>
          <li>Access an Array or Object to create a stream-line of levels</li>
        </ul>
        <p>
        Great. Now That the goal is set, I am going to get going on some tutorials. The Quiz game I mentioned earlier is available in the links listed below.
        <br />
        Moving forward with Javascript, I plan to upload the next weekly Vlog in a few days.

      </p> 
    </article>
  
    <h4>Links</h4>
    <br />
    <ul>
      <li>
        <a
          href="https://ericpolley.github.io/Math-Quiz/"
          title="Math Quiz Game"
        >
          <strong><p>Math Quiz Game</p></strong></a
        >
      </li>
      <li>
        <a
          href="http://erpolley.com"
          title="Check out my website"
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
